
import { Component, Prop, Vue } from 'vue-property-decorator';
import LottieAnimation from '@/components/LottieAnimation.vue';
import { AnimationType } from '@/types';

@Component({
  components: {
    LottieAnimation,
  },
})
export default class PageContentLayoutContainer extends Vue {
  @Prop({ type: String, required: true }) readonly imgName!: string; // name and extension of images in assets/images/context-images/
  @Prop({ type: Object, required: false }) readonly animation:
    | AnimationType
    | undefined;
  @Prop({ type: String, required: true }) pageTitle!: string;
  @Prop({ type: String, default: 'Home' }) next!: string;
  @Prop({ type: String, default: 'Home' }) prev!: string;
  @Prop({ type: Boolean, default: false }) noNav!: boolean; // prop to remove previous and next buttons
}
